var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.from)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"ss-editor"},[_vm._v(" From "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.from.pdb_number))]),_vm._v(" to "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.to.pdb_number))]),_c('input',{staticClass:"confirm control",attrs:{"type":"button","value":"Sheet"},on:{"click":function($event){return _vm.setSecondaryStructures({
          role: _vm.protein.role,
          from: _vm.from,
          to: _vm.to,
          type: 'E',
        })}}}),_c('input',{staticClass:"confirm control",attrs:{"type":"button","value":"Helix"},on:{"click":function($event){return _vm.setSecondaryStructures({
          role: _vm.protein.role,
          from: _vm.from,
          to: _vm.to,
          type: 'H',
        })}}}),_c('input',{staticClass:"confirm control",attrs:{"example-act":"make-coil-button","type":"button","value":"Coil"},on:{"click":function($event){return _vm.setSecondaryStructures({
          role: _vm.protein.role,
          from: _vm.from,
          to: _vm.to,
          type: 'C',
        })}}}),_c('input',{staticClass:"cancel control",attrs:{"type":"button","value":"✕"},on:{"click":_vm.cancel}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }